import { render, staticRenderFns } from "./WebFooter.vue?vue&type=template&id=a51e4f98&scoped=true"
import script from "./WebFooter.vue?vue&type=script&lang=js"
export * from "./WebFooter.vue?vue&type=script&lang=js"
import style0 from "./WebFooter.vue?vue&type=style&index=0&id=a51e4f98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51e4f98",
  null
  
)

export default component.exports